import { FormikHelpers } from "formik";

export const apiToFormikErrors = (res: any, formikHelpers: FormikHelpers<any>) => {
    const errors = res?.data?.errors;
    if (!errors) {
        return;
    }

    for (const { field, message } of errors) {
        formikHelpers.setFieldError(field, message);
    }
};

export function base64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
}
